/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { ValidPropertyType } from '@amplitude/analytics-types';

import { type IntegrationsContextQuery } from '@fai/friendli-suite/generated/client/graphql';

export const parseAmpPropertyEntries = (d: IntegrationsContextQuery) => {
  const properties: Record<string, ValidPropertyType | null> = {
    user_id: d.clientSession?.user?.id ?? null,
    user_name: d.clientSession?.user?.name ?? null,
    user_email: d.clientSession?.user?.email ?? null,
    user_superRoles: d.clientSession?.user?.superRoles?.roles ?? null,
    team_id: d.clientTeam?.id ?? null,
    team_name: d.clientTeam?.name ?? null,
    team_segment: d.clientTeam?.segment ?? null,
    team_serverlessPlan: d.clientTeam?.serverlessSubplan?.tier ?? null,
    team_dedicatedPlan: d.clientTeam?.dedicatedSubplan?.tier ?? null,
    team_containerPlan: d.clientTeam?.containerSubplan?.tier ?? null,
  };

  return Object.entries(properties).filter(([_, value]) => value !== null) as [
    string,
    ValidPropertyType
  ][];
};
